module.exports = __webpack_public_path__ + "static/media/video-thumb.c163f215.png";